//
// Buzzoid (estate-a: same backend platform as Kicksta and Upleap) — Bearer user search.
//   GET <host>/api/v1/instagram/search?context=user&query=<q>      Authorization: Bearer <token>
// Needs SOCIAL_PROV_BUZZOID_EMAIL / _PASSWORD; without them the router skips the lane.
// Host verified 2026-10-31 (api2.buzzoid.com; login answers { status, token }, 7-day JWT, no refresh_token).
//

import { parseIgUserSearch, toIgProfile, browserHeaders } from '../../router/shapes';
import type { Provider, TokenAuthConfig } from '../../router/registry';
import { KICKSTA_TOKEN_AUTH } from './Kicksta';

const HOST = 'https://api2.buzzoid.com';
const SITE = 'https://buzzoid.com';

export const BUZZOID_TOKEN_AUTH: TokenAuthConfig = {
	...KICKSTA_TOKEN_AUTH, // same platform, same login / token shape
	loginUrl: `${HOST}/api/v1/oauth/login`,
};

export const Buzzoid: Provider = {
	id: 'buzzoid',
	platform: 'instagram',
	capabilities: ['search_users', 'profile'],
	family: 'estate-a',
	transport: 'bearer',
	requiresToken: true,
	seedLatencyMs: 1163, // measured by the coordinator 2026-10-31
	tokenAuth: BUZZOID_TOKEN_AUTH,
	request: (req) => ({
		url: req.capability === 'profile'
			? `${HOST}/api/v1/instagram/usernames/${encodeURIComponent(req.query)}`
			: `${HOST}/api/v1/instagram/search?context=user&query=${encodeURIComponent(req.query)}`,
		init: {
			method: 'GET',
			headers: browserHeaders({ Authorization: `Bearer ${req.token}`, Origin: SITE }),
		},
	}),
	parser: (body, req) => (req.capability === 'profile'
		? toIgProfile((body as any)?.data)
		: parseIgUserSearch(body, req.limit)),
};

export default Buzzoid;
